<template>
	<page>
		<module>
			<coupon-list v-if="auth('b_coupon_view')" ></coupon-list>
			<coupon-task-list v-if="auth('b_coupon_task_view')" ></coupon-task-list>
		</module>
	</page>
</template>

<script>
	import couponList from './coupon_list.vue'
	import couponTaskList from './coupon_task.vue'
	
	export default {
		components: {
			couponList,
			couponTaskList
		},
		
		props: {
			tab: String
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
</style>
